import React from 'react';
import { Card, Col, Icon, Row, Slider, Tooltip } from 'antd';
import { Field } from 'redux-form';
import { NumberField, SliderField } from 'redux-form-antd';
import FormValueSelector from '../../../containers/FormValueSelector';

const formFields = {
  colon: false,
  labelCol: {
    xs: { span: 24 },
    sm: { span: 10 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 14 },
  },
};

const ForecastResults = ({ handleSubmit }) => (
  <form onSubmit={handleSubmit} name="ForecastAdjustments">
    {/* Weird workaround for https://github.com/zhDmitry/redux-form-antd/issues/30 */}
    <Slider style={{ display: 'none' }} />

    <Row>
      <Col span={8}>
        <Card title="inHand">
          <Field
            {...formFields}
            name="inhand_product_count"
            label="inHand Product Count"
            component={NumberField}
          />
          <p>
            Estimated scans per visit:{' '}
            <FormValueSelector
              selector={select => ({
                result:
                  Number(select('inhand_product_count')) * Number(select('ease_of_scan') / 100),
              })}
            >
              {({ result }) => result.toFixed(2)}
            </FormValueSelector>
          </p>
          <Field
            colon={false}
            name="ease_of_scan"
            label={
              <FormValueSelector fieldName="ease_of_scan">
                {ease_of_scan => (
                  <span>
                    Ease of Scan: {ease_of_scan}%{' '}
                    <Tooltip title="How common and easy to find is your product in store? A bottle of coke might be 100% while hard to find Organic flax seed flower might be only 20%">
                      <Icon type="question-circle-o" style={{ color: '#08c' }} />
                    </Tooltip>
                  </span>
                )}
              </FormValueSelector>
            }
            component={SliderField}
            tipFormatter={value => `${value}%`}
          />
        </Card>
      </Col>

      <Col span={8} style={{ marginLeft: 20 }}>
        <Card title="inPath / Preceptivity">
          <Field
            {...formFields}
            name="avg_ad_request_per_device"
            label={
              <span>
                Avg. Ad Reqs per Device{' '}
                <Tooltip title="Average ad requests per device per day that we see on our DSP">
                  <Icon type="question-circle-o" style={{ color: '#08c' }} />
                </Tooltip>
              </span>
            }
            component={NumberField}
          />
          <Field
            {...formFields}
            name="inpath_pct_of_requests"
            label={
              <span>
                inPath % of Reqs{' '}
                <Tooltip title="The % of inventory available on our DSP that is 320x480">
                  <Icon type="question-circle-o" style={{ color: '#08c' }} />
                </Tooltip>
              </span>
            }
            component={NumberField}
          />
        </Card>
      </Col>
    </Row>
  </form>
);

export default ForecastResults;
